<template>
    <span>
        <v-tooltip v-if="nuPointSprayModels.some(x => x.Withholding)" v-model="showDetails1" top>
            <template v-slot:activator="{ on, attrs }">                                        
                <v-img :src="require('@/assets/spray.png')" width="25px" v-bind="attrs" v-on="on"></v-img>
            </template>
            <NuPointSprayDetails :nuPointSprayModels="nuPointSprayModels" :show="showDetails1" />
        </v-tooltip>    
        <v-tooltip v-if="nuPointSprayModels.some(x => x.ICA)" v-model="showDetails2" top>
            <template v-slot:activator="{ on, attrs }">                                                                                
                <v-chip dark :color="nuPointSprayModels.filter(x => x.ICA)[0].ICAColour" small v-bind="attrs" v-on="on" class="ica-icon">ICA</v-chip>
            </template>
            <NuPointSprayDetails :nuPointSprayModels="nuPointSprayModels" :show="showDetails2" />
        </v-tooltip>
    </span>
</template>
<script>
import NuPointSprayDetails from "@/components/nuPointSpray/NuPointSpray.vue"

export default {
    components: {
        NuPointSprayDetails
    },      
    props: {
        nuPointSprayModels: {
            type: Array,
            required: true
        }
    },
    data(){
        return {
            showDetails1: false,
            showDetails2: false
        }
    }
}
</script>
<style scoped>
    .ica-icon {
        font-size: 11px;
        width: 26px;
        justify-content: center;
    }
</style>